import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import PillFilterTabs from '@/components/PillFilterTabs'
import useJiriHeaderItems from '@/modules/jiri/useJiriHeaderItems'
import useProfileHeaderItems from '@/modules/profile/useProfileHeaderItems'
import TableCoversByFilter from '@/modules/tableCovers/TableCoversByFilter'
import { TableCoversFilterKey } from '@/redux/slices/tableCoverSlice'
import { useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useState } from 'react'
import { View } from 'react-native'

const FILTER_TABS: { key: TableCoversFilterKey; label: string }[] = [
  { key: TableCoversFilterKey.MyTables, label: '我的表格' },
  { key: TableCoversFilterKey.SharedTables, label: '与我共享' },
]

export default function TableCoversPage() {
  const jiriHeaderItems = useJiriHeaderItems()
  const profileHeaderItems = useProfileHeaderItems()
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)

  const [activeFilter, setActiveFilter] = useState(TableCoversFilterKey.MyTables)

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  const listHeader = (
    <View>
      <PillFilterTabs tabs={FILTER_TABS} activeTag={activeFilter} onSelect={setActiveFilter} />
    </View>
  )

  return (
    <>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: profileHeaderItems, right: jiriHeaderItems }) }} />
      <TableCoversByFilter activeFilter={activeFilter} ListHeaderComponent={listHeader} />
    </>
  )
}
